import request from '@/utils/axios'

// 用户注册
export function userRegister(data) {
  return request({
    url: '/userCenter/register',
    method: 'post',
    data: data
  })
}

// 用户登录
export function userSignIn(data) {
  return request({
    url: '/userCenter/login',
    method: 'post',
    data: data
  })
}

// 获取用户信息
export function fetchUserInfo(data) {
  return request({
    url: '/userCenter/userSetInfo',
    method: 'post',
    data: data
  })
}

// 用户退出
export function userSignOut(data) {
  return request({
    url: '/userCenter/logout',
    method: 'post',
    data
  })
}

// 获取用户绑定安全设置
export function getBindSafety(data) {
  return request({
    url: '/member/loginInfo',
    method: 'post',
    data: data
  })
}

// 获取验证码
export function fetchCaptcha(data) {
  return request({
    url: '/userCenter/getCode',
    method: 'post',
    data: data
  })
}

// 检查验证码
export function doCheckCaptcha(data) {
  return request({
    url: '/userCenter/checkCode',
    method: 'post',
    data: data
  })
}

// 忘记登录密码
export function forgetPassword(data) {
  return request({
    url: '/userCenter/forgetLoginPassword',
    method: 'post',
    data: data
  })
}

// 获取 服务条款 和 隐私政策与声明
export function agreement(id) {
  return request({
    url: `${process.env.VUE_APP_ADMIN_API}/cms/agreement/info/${id}`,
    method: 'get'
  })
}

// 获取可注册的国家列表
export function registerCountryList() {
  return request({
    url: '/userCenter/getNationalList',
    method: 'post'
  })
}

// 查询用户绑定的安全设置 (重置密码前调用)
export function bianSecurityResetPassword(data) {
  return request({
    url: '/member/retrieveInfo',
    method: 'post',
    data: data
  })
}
